/**
 * @generated SignedSource<<ab15690de2a6912df3d430d634cb0e54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RulesUndoInputObject = {
  perspectiveId?: string | null | undefined;
};
export type rulesPage_RulesUndoMutation$variables = {
  input: RulesUndoInputObject;
};
export type rulesPage_RulesUndoMutation$data = {
  readonly rulesUndo: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly undoneKind: string | null | undefined;
  } | null | undefined;
};
export type rulesPage_RulesUndoMutation = {
  response: rulesPage_RulesUndoMutation$data;
  variables: rulesPage_RulesUndoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "undoneKind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_RulesUndoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RulesUndoMutationPayload",
        "kind": "LinkedField",
        "name": "rulesUndo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_RulesUndoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RulesUndoMutationPayload",
        "kind": "LinkedField",
        "name": "rulesUndo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "650734226292faefdeb873d0c8df04bd",
    "id": null,
    "metadata": {},
    "name": "rulesPage_RulesUndoMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_RulesUndoMutation(\n  $input: RulesUndoInputObject!\n) {\n  rulesUndo(input: $input) {\n    undoneKind\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c2ad34c8cc752ff049a9ee5390f0db0";

export default node;
